import { Button } from '@mui/material';
import { useQueryClient } from '@tanstack/react-query';
import { useSnackbar } from 'notistack';
import { useEffect, useState } from 'react';
import CopyToClipboard from 'react-copy-to-clipboard';
import { MEDIA_COOPERATION_SCRIPT } from 'src/constants/queryKeys';
import useFormsModalStore from 'src/store/forms';

// ----------------------------------------------------------------------

export default function MediaCooperationScriptForm() {
  const queryClient = useQueryClient();
  const { setModal, modal, closeModal } = useFormsModalStore();

  const { enqueueSnackbar } = useSnackbar();

  const [textToCopy, setTextToCopy] = useState('');
  const [jsonCopied, setJsonCopied] = useState(false);
  const [srcCopied, setSrcCopied] = useState(false);

  useEffect(() => {
    setJsonCopied(modal.data?.json);
    setSrcCopied(modal.data?.src);
  }, [modal.data?.json, modal.data?.src]);

  const formattedHtml = modal.data?.json;

  // -------------------------------------------------------

  return (
    <div className="px-4 text-left">
      <CopyToClipboard text={srcCopied}>
        <Button
          onClick={() => {
            enqueueSnackbar('آیتم موردنظر با موفقیت کپی شد');
          }}
          size="small"
          color="info"
          className="mb-3"
          variant="contained"
        >
          کپی کردن Script
        </Button>
      </CopyToClipboard>

      <div style={{ direction: 'ltr' }} className="bg-gray-800 mb-4 text-left mt-2 text-green-400 font-mono p-4 rounded-md overflow-auto">
        <pre>
          <code>{modal.data?.src}</code>
        </pre>
      </div>

      <CopyToClipboard text={jsonCopied}>
        <Button
          onClick={() => {
            enqueueSnackbar('آیتم موردنظر با موفقیت کپی شد');
          }}
          size="small"
          color="info"
          className="mb-3"
          variant="contained"
        >
          کپی کردن HTML
        </Button>
      </CopyToClipboard>

      <div style={{ direction: 'ltr' }} className="bg-gray-800 text-left mt-2 text-green-400 font-mono p-4 rounded-md overflow-auto">
        <pre>
          <code>{formattedHtml}</code>
        </pre>
      </div>
    </div>
  );
}
